import { createTheme } from '@cld/component-theme';

export const theme = createTheme({
  container: {
    padding: 'spacing.xs',
    backgroundColor: 'palette.surfaceAlt',
    borderColor: 'palette.secondaryAlt',
    borderRadius: 'radius.lg',
  },
  iconColor: 'palette.contrastLow',
  buttonMargin: 'spacing.xs',
  section: {
    prefix: 'palette.code.accent4',
    kind: 'palette.code.accent7',
    signature: 'palette.code.accent3',
    transformation: 'palette.code.accent9',
    version: 'palette.code.accent6',
    publicId: 'palette.code.accent2',
    ellipsis: 'palette.contrastLow',
  },
});
